import { render } from "./accountPersonalData.vue?vue&type=template&id=3e7246e5"
import script from "./accountPersonalData.vue?vue&type=script&lang=js"
export * from "./accountPersonalData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__